import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=7175e29e&scoped=true&"
import script from "./CopyRight.vue?vue&type=script&lang=js&"
export * from "./CopyRight.vue?vue&type=script&lang=js&"
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=7175e29e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7175e29e",
  null
  
)

export default component.exports